import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { await login(f.email, f.password); } catch (x) { setErr(formatError(x)); }
    setBusy(false);
  };
  return (
    <div className="relative min-h-screen bg-[#1d0702] text-slate-100 flex items-center justify-center px-6">
      <div className="hud-bg" />
      <div className="omx-orbs" aria-hidden="true"><span /><span /><span /><span /><span /><span /></div>
      <form onSubmit={submit} className="relative z-10 hud-panel p-10 w-full max-w-md space-y-5 fade-up" data-testid="login-form">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-xl bg-white flex items-center justify-center"><img src="/omvexis-logo.png" alt="Omvexis" className="h-8" /></span>
          <span className="font-extrabold tracking-[0.3em] text-sm">JARVIS</span>
        </div>
        <h1 className="font-script text-5xl text-white">Welcome back</h1>
        <p className="text-slate-400 text-sm">Omvexis admin access only. Sign in with your Omvexis admin email and password.</p>
        <input className="hud-input" type="email" placeholder="Admin email" autoComplete="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="login-email-input" />
        <input className="hud-input" type="password" placeholder="Password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid="login-password-input" />
        {err && <div className="text-sm text-red-300 border border-red-500/40 bg-red-950/30 rounded-2xl px-4 py-2" data-testid="login-error">{err}</div>}
        <button className="hud-btn w-full justify-center !py-3" disabled={busy} data-testid="login-submit-button">{busy ? <Loader2 size={14} className="animate-spin" /> : <LogIn size={14} />} Sign in</button>
      </form>
    </div>
  );
}
